export const rulesError = (code, message) => ({
    code,
    message,
});
//# sourceMappingURL=errors.js.map